<template>
  <div class="markerDetail" v-show="visible && !uiHiddenState.isHiddenMarker">
    <div v-show="dataSourceType !== 'API'">
      <MarkerAttribute ref="normalMarkerDetail"
        @livePreviewMsg="openLivePreview"
        @previewPicMsg="onPreviewPic"
        @showHTMLEditorMsg="onShowHTMLEditor"
      ></MarkerAttribute>
    </div>
    <ApiMarkerAttribute ref="apiMarkerAttribute" @livePreviewMsg="openLivePreview" @selectPrimitive="onSelectPrimitive" v-show="dataSourceType === 'API'"></ApiMarkerAttribute>
  </div>
</template>

<script>
import MarkerAttribute from './MarkerAttribute'
import ApiMarkerAttribute from './ApiMarkerAttribute'
import { mapGetters } from 'vuex'
export default {
  name: 'MarkerDetails',
  inject: ['shared'],
  data: function () {
    return {
      visible: false,
      dataSourceType: undefined
    }
  },
  components: {
    MarkerAttribute,
    ApiMarkerAttribute
  },
  computed: {
    ...mapGetters(['spaceSearchJeojson', 'uiHiddenState', 'layerList', 'markerDatas']),
    // 是否画布页面
    isMapComponent () {
      return this.$route.name === 'MapComponent'
    }
  },
  methods: {
    async show (data) {
      this.visible = true
      this.dataSourceType = data.dataSourceType
      await this.$nextTick()
      if (this.dataSourceType === 'API') {
        this.$refs.apiMarkerAttribute.show(data)
      } else {
        // 分享界面
        if (this.shared || this.isMapComponent) {
          const markerData = this.getMarkerDataById(data)
          if (markerData.layer.action && markerData.layer.action.uiType === 'none') {
            // 无弹窗
          } else if (markerData.layer.action && markerData.layer.action.uiType === 'live') {
            // 直播弹窗
            this.showLivePreview(markerData)
            // 取消选中
            this.$store.dispatch('selectMarker', undefined)
          } else if (markerData.layer.action && markerData.layer.action.uiType === 'html') {
            // 图文信息
            const html = markerData.marker.geoJson.properties.richSnippets || ''
            this.onShowHTMLEditor({
              markerId: markerData.marker.id,
              markerName: markerData.marker.name,
              html: html
            })
            // 取消选中
            this.$store.dispatch('selectMarker', undefined)
          } else {
            this.$refs.normalMarkerDetail.detail(data)
          }
        } else {
          this.$refs.normalMarkerDetail.detail(data)
        }
      }
    },
    close () {
      if (this.$refs.apiMarkerAttribute.visible) {
        this.$refs.apiMarkerAttribute.close()
      }
      if (this.$refs.normalMarkerDetail.visible) {
        this.$refs.normalMarkerDetail.close()
      }
      this.$emit('closeMarkerAttribute', undefined)
      this.dataSourceType = ''
      this.visible = false
    },
    openLivePreview (data) {
      this.$emit('livePreviewMsg', data)
    },
    onPreviewPic (data) {
      this.$emit('previewPicMsg', data)
    },
    onSelectPrimitive (data) {
      this.$emit('selectPrimitive', data)
    },
    // 获取标注信息
    getMarkerDataById (markerId) {
      for (let i = 0; i < this.markerDatas.length; i++) {
        const datas = this.markerDatas[i]
        if (!datas.marks) {
          continue
        }
        for (let j = 0; j < datas.marks.length; j++) {
          if (String(datas.marks[j].id) === String(markerId)) {
            return {
              layer: datas,
              marker: datas.marks[j]
            }
          }
        }
      }
      return undefined
    },
    // 显示图文弹窗
    onShowHTMLEditor (data) {
      // this.$refs.markerAttributeEditor.show({
      //   ...data
      // })
      this.$emit('showHTMLEditorMsg', data)
    },
    // 显示直播弹窗
    async showLivePreview ({ layer, marker }) {
      // 搜索标注属性中为直播链接的属性
      let property
      layer.properties.forEach(item => {
        if (item.type === 'LIVE' || item.type === 'TW_CODE') {
          property = item
        }
      })
      if (!property) {
        this.$Message('warning', '当前标注所属图层没有类型为直播源的属性')
        return
      }
      if (property.type === 'LIVE') {
        const url = marker.geoJson.properties[property.originPropertyId || property.id]
        if (!url) {
          this.$Message('warning', '当前标注无直播源')
          return
        }
        this.openLivePreview({
          url
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.markerDetail{
  width: 100%;
  height: 100%;
}
</style>
